import React, { FC } from 'react'
import ForwardToInbox from '@mui/icons-material/ForwardToInbox'
import { CalendarVendorContact } from './types'
import NewLayout from './components/NewLayout'

interface ReassignedProps {
  vendorContact: CalendarVendorContact
}

const Reassigned: FC<ReassignedProps> = ({ vendorContact }) => {
  return (
    <NewLayout.Outer>
      <NewLayout.Inner size="xl">
        <div className="tw:flex tw:flex-col tw:items-center tw:gap-6">
          <div className="tw:rounded-full tw:p-6 tw:bg-green-100">
            <ForwardToInbox className="tw:!size-12 tw:text-green-700" />
          </div>
          <p className="tw:text-lg tw:text-center">{`Thank you! ${vendorContact.full_name} will receive an email and see a task in their portal to review and book.`}</p>
        </div>
      </NewLayout.Inner>
    </NewLayout.Outer>
  )
}

export default Reassigned
